module.exports = __webpack_public_path__ + "static/media/APP_RisingStar_152x174_1.85bb7e3a.png";